import { render, staticRenderFns } from "./SoftVersionIcon.vue?vue&type=template&id=94dfab44&"
import script from "./SoftVersionIcon.vue?vue&type=script&lang=ts&"
export * from "./SoftVersionIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94dfab44')) {
      api.createRecord('94dfab44', component.options)
    } else {
      api.reload('94dfab44', component.options)
    }
    module.hot.accept("./SoftVersionIcon.vue?vue&type=template&id=94dfab44&", function () {
      api.rerender('94dfab44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/SoftVersionIcon/components/mobile/SoftVersionIcon.vue"
export default component.exports